import { get, post, postJson, put, deleteApi,postUrl } from './axios'

const RESOURCE_BASE_PATH = '/sms-templates'
// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms/sms-templates'

// 获取自定义栏目
export const getTemplateDir = p => get(`${RESOURCE_BASE_PATH}/templateDir`, p);

// 获取模板列表
export const getTemplatesPage = p => get(`${RESOURCE_BASE_PATH}/templates/page`, p);

// 获取精准营销获取模板的栏目
export const getSpecialList = p => get(`${RESOURCE_BASE_PATH}/templateDir/specialList`, p);

// 创建模板
export const createTemplate = p => postJson(`${RESOURCE_BASE_PATH}/template`, p);

// 添加栏目
export const createAddColumn = p => postUrl(`${RESOURCE_BASE_PATH}/templateDir`, p);

// 获取子栏目
export const getTemplateChild = p => get(`${RESOURCE_BASE_PATH}/templateDir/child`, p);

// 修改模板
export const updateTemplate = p => put(`${RESOURCE_BASE_PATH}/template`, p);

// 删除模板
export const deleteTemplate = p => deleteApi(`${RESOURCE_BASE_PATH}/template`, p);

// 删除栏目
export const deleteTemplateDir = p => deleteApi(`${RESOURCE_BASE_PATH}/templateDir`, p);

// 获取官方栏目
export const getOfficialTemplateDir = p => get(`${RESOURCE_BASE_PATH}/templateDir/select`, p);

// 创建商家申请官方模板
export const addCustomerOfficialTemplate = p => postJson(`${RESOURCE_BASE_PATH}/addCustomerOfficialTemplate`, p);

// 提交商家创建模板
export const commitOfficialTemplate = p => postJson(`${RESOURCE_BASE_PATH}/commitOfficialTemplate`, p);

// 删除商家申请官方模板
export const delBusApplyTemplate = p => deleteApi(`${RESOURCE_BASE_PATH}/delBusApplyTemplate`, p);

// 获取富信模板列表
export const getSmsMediaTemplate = p => get(`/sms-media-template/page`, p);

// 富信模板详情
export const getSmsMediaTemplateDetail = p => get(`/sms-media-template/detail/` + p);

// 富信模板删除
export const smsMediaTemplateDelete = p => deleteApi(`/sms-media-template/delete/` + p);

// 富信模板保存
export const smsMediaTemplateSave = p => postJson(`/sms-media-template/save` , p);